import AdminList from "./index";

export const adminRoutes = () => [
  {
    path: "/admin/users/admin",
    component: AdminList,
    layout: "admin",
    routeType: "admin",
    title: "Admin Management",
  },
];
